import { useColorMode } from '@vueuse/core'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export type colorMode = 'dark' | 'light' | 'auto'

export const useConfigStore = defineStore(
	'config-store',
	() => {
		const isNavbarVerticalCollapsed = ref(true)
		const isRTL = ref(false)
		const isFluid = ref(false)
		const navbarStyle = ref('transparent')
		const navbarPosition = ref('vertical')
		const colorMode = useColorMode<colorMode>({
			emitAuto: true,
			attribute: 'data-bs-theme'
		})

		function changeTheme(themeVal: colorMode) {
			colorMode.value = themeVal
		}

		return {
			isNavbarVerticalCollapsed,
			isRTL,
			isFluid,
			navbarStyle,
			navbarPosition,
			colorMode,
			changeTheme
		}
	},
	{
		persist: true
	}
)
